module.exports = __webpack_public_path__ + "img/pasta-banner-pc.d5ebc483.jpg";